import { render, staticRenderFns } from "./StudentClassProjectionCoordinatorAddEdit.vue?vue&type=template&id=4a9d88e8"
import script from "./StudentClassProjectionCoordinatorAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentClassProjectionCoordinatorAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports